import React from 'react';

export default function CartDrawer({
  isOpen,
  onClose,
  cartPets,
  cartName,
  setCartName,
  cartLocation,
  setCartLocation,
  cartNotes,
  setCartNotes,
  onRemoveFromCart,
  onClearCart,
  onCheckoutToWhatsApp
}) {
  if (!isOpen) return null;

  return (
    <div className="cart-overlay" role="dialog" aria-label="Pup cart" onClick={onClose}>
      <div className="cart-drawer" onClick={(e) => e.stopPropagation()}>
        <div className="cart-header">
          <div className="cart-title">Enquiry List</div>
          <button className="cart-close" type="button" onClick={onClose} aria-label="Close cart">
            ✕
          </button>
        </div>

        {cartPets.length ? (
          <>
            <div className="cart-list">
              {cartPets.map((p) => (
                <div className="cart-item" key={p.id}>
                  <div className="cart-item-thumb">
                    {p.images?.[0] ? <img src={p.images[0]} alt="" /> : <div className="photo-placeholder" aria-hidden="true" />}
                  </div>
                  <div className="cart-item-meta">
                    <div className="cart-item-name">{p.title}</div>
                    <div className="cart-item-sub">
                      {[p.age, p.size, p.weight].filter((x) => x && x !== 'Ask for details').join(' • ') ||
                        'Details on request'}
                    </div>
                  </div>
                  <button className="cart-remove" type="button" onClick={onRemoveFromCart(p.id)}>
                    Remove
                  </button>
                </div>
              ))}
            </div>

            <div className="cart-form">
              <label className="cart-field">
                <span>Your name (optional)</span>
                <input value={cartName} onChange={(e) => setCartName(e.target.value)} placeholder="e.g. John" />
              </label>
              <label className="cart-field">
                <span>Your location (optional)</span>
                <input
                  value={cartLocation}
                  onChange={(e) => setCartLocation(e.target.value)}
                  placeholder="e.g. Dallas, TX"
                />
              </label>
              <label className="cart-field">
                <span>Notes (optional)</span>
                <textarea
                  value={cartNotes}
                  onChange={(e) => setCartNotes(e.target.value)}
                  rows={3}
                  placeholder="Pickup or shipping preference, questions…"
                />
              </label>
            </div>

            <div className="cart-actions">
              <button className="cart-secondary" type="button" onClick={onClearCart}>
                Clear
              </button>
              <button className="cart-primary" type="button" onClick={onCheckoutToWhatsApp}>
                Send enquiry to WhatsApp
              </button>
            </div>
          </>
        ) : (
          <div className="cart-empty">
            <div className="cart-empty-title">No pups selected yet</div>
            <div className="cart-empty-sub">Add pups from the catalogue, then send your enquiry on WhatsApp.</div>
          </div>
        )}
      </div>
    </div>
  );
}
